import React, { useState, useEffect } from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Icon, Message } from "semantic-ui-react";

import {
    SG_ADD_FILE_UPLOAD,
    CLEAR_CREATED_FILE_UPLOAD,
} from "constants/actions";

const FileUpload = ({
    organizationId,
    setShowReportId,
    setShowPage,
    AllPageOptions,
    setResetPageLoad,
    BackToHomePage,
}) => {
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const { addToast } = useToasts();

    useEffect(() => {
        dispatch({
            type: CLEAR_CREATED_FILE_UPLOAD,
        });
    }, [dispatch]);

    const { get_file_uploads } = useSelector(
        (state) => ({
            get_file_uploads: state.fileupload,
        }),
        shallowEqual
    );

    useEffect(() => {
        if (get_file_uploads?.created?.id) {
            setShowPage(AllPageOptions[1]);
            setShowReportId(get_file_uploads?.created?.id);
        }
    }, [get_file_uploads, setShowReportId, setShowPage, AllPageOptions]);

    const onClickSave = () => {
        const event = new Date();
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };

        const TodayDate = event.toLocaleDateString(undefined, options);
        
        if (organizationId) {
            dispatch({
                type: SG_ADD_FILE_UPLOAD,
                payload: {
                    name: `Uploaded on ${TodayDate}`,
                    organization: organizationId,
                    data_file: uploadedFiles,
                },
            });
            setUploadedFiles(false);
            addToast("File Successfully Uploaded", {
                appearance: "success",
                autoDismiss: true,
            });
            setResetPageLoad(`${organizationId} Uploaded on ${TodayDate}`)
        
            const timer1 = setTimeout(() => {
                BackToHomePage()
              }, 2000)
              return () => clearTimeout(timer1)
        }
    };

    const handleDrop = (dropped) => {
        if (dropped[0]?.name.split(".").pop() === "csv") {
            setUploadedFiles(dropped[0]);
        } else {
            setErrorMessage(`The file ${dropped[0]?.name} is not a CSV file`);
        }
    };

 

    const { fileRejections } =
        useDropzone({
            accept: "text/csv",
        });


    useEffect(() => {
        setErrorMessage(fileRejections[0]?.errors[0]?.message);
    }, [fileRejections]);

    return (
        <>
            <div
                aria-labelledby="max-width-dialog-title"
                style={{ paddingLeft: 30 }}
            >
                {errorMessage && (
                    <Message
                        negative
                        onDismiss={() => setErrorMessage(false)}
                        header="There was an Error!"
                        content={errorMessage}
                    />
                )}

                <div className="dialog">
                    <P>Drag &amp; Drop your File here</P>

                    <Dropzone
                        onDrop={handleDrop}
                        noKeyboard
                        maxFiles={1}
                        multiple={false}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <Box
                                {...getRootProps()}
                                file={uploadedFiles?.length > 0}
                            >
                                {uploadedFiles?.name ? (
                                    <InnerBox
                                        onClick={() => setUploadedFiles([])}
                                    >
                                        {" "}
                                        {uploadedFiles?.name}{" "}
                                        <Icon name="cancel" />
                                    </InnerBox>
                                ) : (
                                    <p>
                                        {" "}
                                        <Icon name="upload" /> Drag 'n' drop CSV
                                        files here, or click to select CSV files
                                        to upload
                                    </p>
                                )}

                                {<input {...getInputProps()} />}
                            </Box>
                        )}
                    </Dropzone>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {uploadedFiles?.name && (
                        <StyledButton
                            onClick={() => onClickSave()}
                            color="grey"
                        >
                            Upload File
                        </StyledButton>
                    )}
                </div>
            </div>
        </>
    );
};

export default FileUpload;

const P = styled.p`
    font-size: 16px;
    font-family: "Barlow", sans-serif;
`;

const StyledButton = styled.button`
    color: white;
    font-size: 14px;
    font-family: "Barlow Semi Condensed", sans-serif;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 5px;
    background-color: #2d50e2;
    border: none;
    outline: none;
    padding: 0px 30px;
    border: 1px solid white;
    margin-right: 5px;

    @media (max-width: 768px) {
        height: 30px;
        font-size: 12px;
        padding: 0 10px 0 10px;
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0);
        border: 1px solid #2d50e2;
        color: #2d50e2;
    }
`;

const Box = styled.div`
    border-radius: 10px;
    border: 1px solid #e9e9e9;
    display: flex;
    align-items: center;
    padding: 20px;
    width: 100%;
    position: relative;
    margin-bottom: 30px;
    cursor: ${(props) => (props.file ? "default" : "pointer")};
    //   cursor:pointer;
    //   @media (max-width:768px){
    //     width:250px;
    //   }
`;
const InnerBox = styled.div`
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    display: flex;
    align-items: center;
    margin: 10px;
    padding: 15px;
    cursor: pointer;
    background-color: #dcdcdc;
`;
